class faqBlock extends HTMLElement {
  constructor() {
    super();
    this.currentURL = new URL(window.location.href);
  }

  connectedCallback() {
    if (this.currentURL.href.includes('#')) {
      this.openFaqItem(this.currentURL.hash)
    }
  }

  openFaqItem(item) {
    let faqElement = this.querySelector(item)
    faqElement.setAttribute('open','');
    faqElement.scrollIntoView({behavior: 'auto'})
  }

}

customElements.define('faq-block', faqBlock);
